import type { Position, PositionStatus } from "@/types/api";
import { request } from "./transport";

export interface PositionInput {
  ticker?: string;
  status?: PositionStatus;
  source_saved_strategy_id?: string | null;
  source_simulator_tab_id?: string | null;
  source_watch_position_id?: string | null;
  layers_snapshot?: readonly unknown[];
  legs_snapshot?: readonly unknown[];
  plan_scenario?: Record<string, unknown>;
  entry_scenario?: Record<string, unknown>;
  entry_spot?: number | null;
  entry_iv?: number | null;
  entry_credit?: number | null;
  entry_debit?: number | null;
  contracts?: number;
  fees?: number;
  planned_at?: string | null;
  opened_at?: string;
  closed_at?: string | null;
  exit_spot?: number | null;
  exit_iv?: number | null;
  exit_scenario?: Record<string, unknown>;
  exit_credit?: number | null;
  exit_debit?: number | null;
  realized_pnl?: number | null;
  notes?: string | null;
}

export type PositionCollection = "visible" | "archived" | "hidden";

export const positions = {
  listPositions: (params?: {
    collection?: PositionCollection;
    status?: PositionStatus;
    ticker?: string;
  }) => {
    const qs = new URLSearchParams();
    if (params?.collection) qs.set("collection", params.collection);
    if (params?.status) qs.set("status", params.status);
    if (params?.ticker) qs.set("ticker", params.ticker);
    const q = qs.toString();
    return request<{ positions: Position[] }>(`/positions${q ? `?${q}` : ""}`);
  },

  getPosition: (id: string) =>
    request<{ position: Position }>(`/positions/${id}`),

  createPosition: (input: PositionInput) =>
    request<{ position: Position }>("/positions", {
      method: "POST",
      body: JSON.stringify({ position: input }),
    }),

  updatePosition: (id: string, patch: PositionInput) =>
    request<{ position: Position }>(`/positions/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ position: patch }),
    }),

  archivePosition: (id: string) =>
    request<{ position: Position }>(`/positions/${id}/archive`, {
      method: "PATCH",
    }),

  hidePosition: (id: string) =>
    request<{ position: Position }>(`/positions/${id}/hide`, {
      method: "PATCH",
    }),

  restorePosition: (id: string) =>
    request<{ position: Position }>(`/positions/${id}/restore`, {
      method: "PATCH",
    }),

  deletePosition: (id: string) =>
    request<{ ok: true }>(`/positions/${id}`, { method: "DELETE" }),
};
